import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownOptions, EnglishArabicDTO, FilterItem, FilterType, InputType, MultiLingualTextBoxOptions, PagingOptions, TextBoxOptions } from 'bnsights-control-library';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { PermissionSetModel } from '../../shared/models/PermissionsModels/PermissionSetModel';
import { UsersIDRequestModel } from '../../shared/models/UserModels/UsersIDRequestModel';
import { DataSecretService } from '../../shared/Services/data.service';
import { PermissionSetService } from '../../shared/Services/PermissionSetService.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';


@Component({
  selector: 'lib-permissionsets',
  templateUrl: './permissionsets.component.html'
})
export class PermissionsetsComponent implements OnInit {
  SubheaderTitle = this.utilityService.getResourceValue('PermissionSets');
  

  ShowToolbar = true; ShowbreadCrumb = false;
  ApiUrl = "/api/admin/PermissionSets/"
  searchTextBox: TextBoxOptions;
  PermissionList = [];
  OrganizationList = [];
  filterForm = new FormGroup({});
  PermissionSetForm = new FormGroup({});
  showFilter: boolean = false;
  PermissionSetPagingResult: any[] = [];
  PermissionSetPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;
  @ViewChild('PermissionSetPagingViewElement', { static: false }) input: ElementRef;


  //Add Model Controls
  AddPermissionSetForm = new FormGroup({});
  MultiLingualName:MultiLingualTextBoxOptions
  SysName: TextBoxOptions;
  ActiveDirectoryGroup: TextBoxOptions;
  Permissions: DropdownOptions;
  Organization: DropdownOptions;
  @ViewChild('ClosePermissionSetModal', { static: false }) ClosePermissionSetModal: ElementRef;

  //Edit Model Controls
  EditPermissionSetForm = new FormGroup({});
  EditMultiLingualName:MultiLingualTextBoxOptions
  EditSysName: TextBoxOptions;
  EditActiveDirectoryGroup: TextBoxOptions;
  EditPermissions: DropdownOptions;
  EditOrganization: DropdownOptions;
  PermissionSetId: number;
  @ViewChild('CloseEditPermissionSetModal', { static: false }) CloseEditPermissionSetModal: ElementRef;

  //delete  Model Controls
  deletePermissionSetList: any[] = []
  @ViewChild('CloseDeletePermissionSetModal', { static: false }) CloseDeletePermissionSetModal: ElementRef;
  language:string=""
  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;
  ShowPageContent:boolean=false;

  constructor(private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService,private dataServices: DataSecretService, private authService: AuthService, private PermissionSetService: PermissionSetService, private modalService: NgbModal) {
  }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("PermissionSets")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadDropdownLists();
  }
 
 
  LoadDropdownLists() {

    this.PermissionSetService.Loaddropdowns().subscribe((result) => {
      let DropdownsResponseModel = result;
      this.OrganizationList = DropdownsResponseModel["organizationList"];
      this.PermissionList = DropdownsResponseModel["permissionList"];
      // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.HideLabel = true;
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName");

      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox

      this.PermissionSetPaging = new PagingOptions();
      this.PermissionSetPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetPermissionSetsByFilter';
      this.PermissionSetPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.PermissionSetPaging.Filters = [this.TextInputFilter]
      this.PermissionSetPaging.ValidationToken = this.authService.authorizationHeaderValue()
      this.IsFilterLoaded = true;
       
    })
  }

  ReinitializePermissionSetPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdatePermissionSetPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setPermissionSetListResult(result) {
    console.log(result);
    this.PermissionSetPagingResult = result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }

  resetFilters() {
    this.PermissionSetForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  showAddPermissionSetModal(addPermissionSetModal) {
    this.utilityService.startBlockUI();
    this.AddPermissionSetForm = new FormGroup({});

    this.MultiLingualName = new MultiLingualTextBoxOptions();
    this.MultiLingualName.Name = "Name";
    this.MultiLingualName.ArabicLabelKey = "NameInArabic";
    this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.MultiLingualName.IsRequired = true;
    this.MultiLingualName.Value = null;

    this.ActiveDirectoryGroup = new TextBoxOptions();
    this.ActiveDirectoryGroup.Name = "ActiveDirectoryGroup";
    this.ActiveDirectoryGroup.LabelKey = "ActiveDirectoryGroup";
    this.ActiveDirectoryGroup.Type = InputType.Text;
    this.ActiveDirectoryGroup.Value = null;


    this.SysName = new TextBoxOptions();
    this.SysName.Name = "SysName";
    this.SysName.LabelKey = "SysName";
    this.SysName.Type = InputType.Text;
    this.SysName.Value = null;

    this.Permissions = new DropdownOptions();
    this.Permissions.Name = "Permissions"
    this.Permissions.LabelKey = "Permissions"
    this.Permissions.SelectedItems = null;
    this.Permissions.DataSource = this.PermissionList
    this.Permissions.SingleSelection = false;
    this.Permissions.AllowSearchFilter = true;


    this.Organization = new DropdownOptions();
    this.Organization.Name = "Organization"
    this.Organization.LabelKey = "Organization"
    this.Organization.SelectedItems = null;
    this.Organization.DataSource = this.OrganizationList
    this.Organization.SingleSelection = true;
    this.Organization.AllowSearchFilter = true;
    this.Organization.IsRequired = true;

    this.modalService.open(addPermissionSetModal);
    this.utilityService.stopBlockUI();
  }

  addPermissionSet() {
    if (this.AddPermissionSetForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddPermissionSetForm.value;
      let AddPermissionSetModel:PermissionSetModel= new PermissionSetModel() ;
      if (this.ProductionMode == false)
        AddPermissionSetModel.SysName = ResultModel.SysName;
      AddPermissionSetModel.Name.Arabic = ResultModel.Name.ArabicValue;
      AddPermissionSetModel.Name.English = ResultModel.Name.EnglishValue;
    
      AddPermissionSetModel.OrganizationID = Number(ResultModel.Organization);
      let Ids = [];
      if (ResultModel.Permissions != null) {
        for (let index = 0; index < ResultModel.Permissions.length; index++) {
          const element = ResultModel.Permissions[index];
          Ids.push(Number(element));
        }
      }
      AddPermissionSetModel.PermissionIDs =Ids;
      this.PermissionSetService.AddPermissionSet(AddPermissionSetModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      })
    }
  }


  showEditPermissionSetModal(PermissionSet: any, editPermissionSetModal) {
    this.utilityService.startBlockUI();
    this.EditPermissionSetForm = new FormGroup({});

    let Name=new EnglishArabicDTO();
    Name.Arabic=PermissionSet.name.arabic;
    Name.English=PermissionSet.name.english;

    this.EditMultiLingualName = new MultiLingualTextBoxOptions();
    this.EditMultiLingualName.Name = "Name";
    this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
    this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.EditMultiLingualName.IsRequired = true;
    this.EditMultiLingualName.Value = Name;

    this.PermissionSetId = PermissionSet.id

    this.EditActiveDirectoryGroup = new TextBoxOptions();
    this.EditActiveDirectoryGroup.Name = "ActiveDirectoryGroup";
    this.EditActiveDirectoryGroup.LabelKey = "ActiveDirectoryGroup";
    this.EditActiveDirectoryGroup.Type = InputType.Text;
    this.EditActiveDirectoryGroup.Value = PermissionSet.activeDirectoryGroup;


    this.EditSysName = new TextBoxOptions();
    this.EditSysName.Name = "SysName";
    this.EditSysName.LabelKey = "SysName";
    this.EditSysName.Type = InputType.Text;
    this.EditSysName.Value = PermissionSet.sysName;


    let selectedPermissionList = [];
    for (let index = 0; index < PermissionSet.permissionIDs.length; index++) {
      const Permission = this.PermissionList.filter((item) => { return parseInt(item.key) == PermissionSet.permissionIDs[index]; }).map((item) => item.key)[0];
      selectedPermissionList.push(Permission)
    }
    this.EditPermissions = new DropdownOptions();
    this.EditPermissions.Name = "Permissions"
    this.EditPermissions.LabelKey = "Permissions"
    this.EditPermissions.SelectedItems = selectedPermissionList;
    this.EditPermissions.DataSource = this.PermissionList
    this.EditPermissions.SingleSelection = false;
    this.EditPermissions.AllowSearchFilter = true;

    this.EditOrganization = new DropdownOptions();
    this.EditOrganization.Name = "Organization"
    this.EditOrganization.LabelKey = "Organization"
    this.EditOrganization.SelectedItems = this.OrganizationList.filter((item) => { return parseInt(item.key) == PermissionSet.organizationID; }).map((item) => item.key)[0];
    this.EditOrganization.DataSource = this.OrganizationList
    this.EditOrganization.SingleSelection = true;
    this.EditOrganization.AllowSearchFilter = true;
    this.EditOrganization.IsRequired = true;

    this.modalService.open(editPermissionSetModal);
    this.utilityService.stopBlockUI();

  }

  editPermissionSet() {
    if (this.EditPermissionSetForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.EditPermissionSetForm.value;
      let EditPermissionSetModel:PermissionSetModel= new PermissionSetModel();
      EditPermissionSetModel.Id = this.PermissionSetId;
      EditPermissionSetModel.Name.Arabic = ResultModel.Name.ArabicValue;
      EditPermissionSetModel.Name.English = ResultModel.Name.EnglishValue;
      if (this.ProductionMode == false)
        EditPermissionSetModel.SysName = ResultModel.SydName;
      EditPermissionSetModel.OrganizationID = Number(ResultModel.Organization);
      let Ids = [];
      if (ResultModel.Permissions != null) {
        for (let index = 0; index < ResultModel.Permissions.length; index++) {
          const element = ResultModel.Permissions[index];
          Ids.push(Number(element));
        }
      }
      EditPermissionSetModel.PermissionIDs =Ids;
      this.PermissionSetService.EditPermissionSet(EditPermissionSetModel).subscribe((result) => {
        this.modalService.dismissAll();
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      })
    }
  }

  showDeletePermissionSetModal(Resource: any,deletePermissionSetModal) {
    this.utilityService.startBlockUI();
    this.deletePermissionSetList = []
    this.deletePermissionSetList.push(Resource);
    this.modalService.open(deletePermissionSetModal);
    this.utilityService.stopBlockUI();

  }

  deletePermissionSet() {
    let  UsersIDModel:UsersIDRequestModel= new UsersIDRequestModel() ;
     for (let index = 0; index < this.deletePermissionSetList.length; index++) {
       const element = this.deletePermissionSetList[index];
       UsersIDModel.UsersIDs.push(element.id)
       
     }
    this.PermissionSetService.DeletePermissionSet(UsersIDModel).subscribe((result) => {
      let data = result as any;
      if (!data.val) {
        this.utilityService.notifyErrorMessage(this.utilityService.getResourceValue("CannotDeletePermissionSetHasUsers"));
      }
      else {
        this.utilityService.notifySuccessMessage()
      }
      this.deletePermissionSetList = [];
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
      
    })

  }

  SaveName(name) {
    let Name = {
        English: name.english,
        Arabic: name.arabic,
    };
    localStorage.setItem("PermissionSetName", JSON.stringify(Name));
}

}
